import type { finalists } from "@/mocks/finalists";

type Finalist = (typeof finalists)[number];

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  steady: "ri-subtract-line",
};

const trendColor: Record<string, string> = {
  up: "text-primary-600",
  down: "text-secondary-600",
  steady: "text-foreground-500",
};

export default function FinalistCard({ item }: { item: Finalist }) {
  return (
    <article className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden flex flex-col">
      <div className="relative w-full h-44 overflow-hidden">
        <img
          src={item.image}
          alt={`${item.title} — ${item.categoryName}入围作品配图`}
          title={`${item.title} · 爆料大赛入围作品`}
          className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-secondary-950/80 text-background-50 text-xs font-medium backdrop-blur">
          {item.categoryName}
        </span>
        <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-accent-500 text-accent-950 text-xs font-bold">
          {item.score.toFixed(1)}
        </span>
      </div>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <h3 className="font-heading text-lg tracking-wide text-foreground-950 mb-2">{item.title}</h3>
        <p className="text-sm leading-relaxed text-foreground-600 line-clamp-3 flex-1">{item.summary}</p>

        <div className="mt-4 flex flex-wrap gap-1.5">
          {item.tags.map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-md bg-background-100 text-foreground-600 text-xs">
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-line" />
            {item.author}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-thumb-up-line" />
              {item.votes.toLocaleString("zh-CN")}
            </span>
            <span className={`flex items-center gap-0.5 font-medium ${trendColor[item.trend]}`}>
              <i className={trendIcon[item.trend]} />
              {item.rankChange === 0 ? "持平" : Math.abs(item.rankChange)}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}
